<template>
  <transition name="tc-modal-fade">
    <div v-if="model" class="tc-overlay" :class="{ 'tc-overlay--dark': $vuetify.theme.dark }" @mousedown.self="model = false">
      <div class="tc-modal">
        <!-- Header -->
        <div class="tc-modal__header">
          <h2 class="tc-modal__title">{{ object.id ? $t("Tahrirlash") : $t("Yangi o'qituvchi") }}</h2>
          <button class="tc-modal__close" @click="model = false">
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>
          </button>
        </div>

        <!-- Body -->
        <div class="tc-modal__body">
          <div class="tc-field">
            <label class="tc-field__label">{{ $t("F.I.O") }} <span class="tc-field__req">*</span></label>
            <input
              ref="nameInput"
              v-model="object.name"
              type="text"
              class="tc-field__input"
              :class="{ 'tc-field__input--error': submitted && !object.name }"
              :placeholder="$t('Ism familiya...')"
            />
            <span v-if="submitted && !object.name" class="tc-field__error">{{ $t("Maydon to'ldirilishi shart") }}</span>
          </div>

          <div class="tc-field">
            <label class="tc-field__label">{{ $t("Fan") }}</label>
            <input
              v-model="object.subject"
              type="text"
              class="tc-field__input"
              :placeholder="$t('Masalan: Matematika')"
            />
          </div>
        </div>

        <!-- Footer -->
        <div class="tc-modal__footer">
          <button class="tc-modal__btn tc-modal__btn--cancel" @click="model = false">{{ $t("Bekor qilish") }}</button>
          <button class="tc-modal__btn tc-modal__btn--save" @click="onSend">{{ $t("Saqlash") }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    object: {
      id: null,
      name: null,
      subject: null,
    },
    model: true,
    submitted: false,
  }),

  watch: {
    model(val) {
      if (!val) {
        setTimeout(() => {
          this.$emit("close");
        }, 200);
      }
    },
  },

  created() {
    if (this.data.id) {
      this.object = JSON.parse(JSON.stringify(this.data));
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.nameInput) this.$refs.nameInput.focus();
    });
  },

  methods: {
    ...mapActions("admin-teachers", ["ADD_TEACHER"]),

    onSend() {
      this.submitted = true;
      if (!this.object.name) return;

      this.ADD_TEACHER(this.object).then((status) => {
        if (status != null) {
          this.$emit("refresh");
          this.model = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tc-overlay {
  --card: #fff;
  --border: rgba(0,0,0,.08);
  --text: #0f172a;
  --text2: #475569;
  --muted: #94a3b8;
  --accent: #ffd451;
  --accent-hover: #f5c542;

  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.4);
  backdrop-filter: blur(4px);
}

.tc-overlay--dark {
  --card: #1a1b23;
  --border: rgba(255,255,255,.08);
  --text: #e4e5eb;
  --text2: #9ca3af;
  --muted: #606275;
  background: rgba(0,0,0,.6);
}

.tc-modal {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  width: 460px;
  max-width: calc(100vw - 32px);
  box-shadow: 0 24px 48px rgba(0,0,0,.16), 0 4px 12px rgba(0,0,0,.08);
  animation: tc-modal-in .2s ease;
}

@keyframes tc-modal-in {
  from { opacity: 0; transform: translateY(12px) scale(.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Header ── */
.tc-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
}

.tc-modal__title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  margin: 0;
  letter-spacing: -0.01em;
}

.tc-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: none;
  color: var(--muted);
  cursor: pointer;
  transition: all .15s;
}
.tc-modal__close:hover {
  background: var(--border);
  color: var(--text);
}

/* ── Body ── */
.tc-modal__body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tc-field__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2);
  margin-bottom: 6px;
}

.tc-field__req {
  color: #ef4444;
}

.tc-field__input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: transparent;
  color: var(--text);
  font-size: 14px;
  outline: none;
  transition: border-color .15s, box-shadow .15s;

  &::placeholder { color: var(--muted); }
  &:focus {
    border-color: #00274c;
    box-shadow: 0 0 0 3px rgba(0,39,76,.15);
  }
}

.tc-field__input--error {
  border-color: #ef4444 !important;
  &:focus {
    box-shadow: 0 0 0 3px rgba(239,68,68,.1);
  }
}

.tc-field__error {
  display: block;
  font-size: 12px;
  color: #ef4444;
  margin-top: 4px;
}

/* ── Footer ── */
.tc-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 24px 20px;
}

.tc-modal__btn {
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s;
  border: 1px solid var(--border);
}

.tc-modal__btn--cancel {
  background: transparent;
  color: var(--text2);
  &:hover { background: var(--border); color: var(--text); }
}

.tc-modal__btn--save {
  background: var(--accent);
  border-color: var(--accent);
  color: #0f172a;
  &:hover { background: var(--accent-hover); border-color: var(--accent-hover); }
}

/* ── Transition ── */
.tc-modal-fade-enter-active, .tc-modal-fade-leave-active {
  transition: opacity .2s ease;
}
.tc-modal-fade-enter, .tc-modal-fade-leave-to {
  opacity: 0;
}
</style>
